export default {"src":"/_next/static/media/PersonalDetails.7f2b662f.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};